import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, SyncData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import BillPrint from './Bill';
import CircularProgress from '@mui/material/CircularProgress';

function RentListIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();
        setLoading(true);
    }, [isAuthenticated, companyId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    // here 4 parameter passing to help loading the infinte no:of data in index and fast loading 

    // Function to fetch table data and set state
    const fetchTableData = async () => {

        setData([]);
        setLoading(true);
        try {
            const response = await fetchData('RentCollectionsApi', `/CustomerDetails/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
            console.log(response);
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
        finally {
            setLoading(false); // Hide loading screen
        };

    };

    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }


    const handlePrint = async (RentcollectionID) => {
        try {
            // Fetch data
            const response = await fetchData('RentCollectionsApi', `/${RentcollectionID}`, token);
            const labelData = response.response_data;
            console.log(response);
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');


            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,

                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            iframe.contentWindow.print();

            try {
                await SyncData('RentCollectionsApi', `${RentcollectionID}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex flex-wrap items-center'>
                <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    Rent List
                </h5>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div className='flex items-center mb-2 md:mb-0'>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '150px' }}
                        />
                    )}
                </div>
                <div className='flex flex-col md:flex-row items-center mb-2 md:mb-0'>
                    <div className='flex flex-col md:mr-2 max-w-full md:max-w-xs'>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1" htmlFor="fromDate">
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                        />
                    </div>
                    <div className='flex flex-col md:ml-2 max-w-full md:max-w-xs'>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1" htmlFor="toDate">
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                        />
                    </div>
                </div>
                <Button
                    style={{
                        marginTop: '20px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'white' }} />
                    </IconButton>
                    <span style={{ color: 'white', fontWeight: 'bolder', marginLeft: '5px' }}>Refresh</span>
                </Button>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                            <TableRow>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '3%' }}>Sl.No</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '7%' }}>Bill Date</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '10%' }}>Bill Number</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>Customer Name</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '20%' }}>Contact Number</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '7%' }}>Room</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '7%', textAlign: 'center' }}>Amount</TableCell>
                                <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '#f9f9f9' }}>
                            {filteredData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={8} sx={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: '#555' }}>No data found</TableCell>
                                </TableRow>
                            ) : (
                                filteredData.map((item, index) => (
                                    <TableRow
                                        key={item.id}
                                        sx={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#e0e0e0' }} // Alternating light colors
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '7%', fontSize: '14px' }}>{formatDate(item.BillDate)}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '10%', fontSize: '14px' }}>{item.BillNo}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '15%', fontSize: '14px' }}>{item.customerName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '20%', fontSize: '14px' }}>{item.phone}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '7%', fontSize: '14px' }}>{item.roomName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.Amount ? item.Amount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '7px', textAlign: 'center' }}>
                                            <Tooltip title="Generate Bill">
                                                <IconButton onClick={() => handlePrint(item.ID)}>
                                                    <PrintIcon style={{ color: 'darkblue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div >
        </div >

    );
}

export default RentListIndex;

